"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var useMediaQuery_1 = __importDefault(require("../useMediaQuery"));
var Modal_styles_1 = require("./Modal.styles");
var ModalContext_1 = __importDefault(require("./ModalContext"));
var Page = function (_a) {
    var pageId = _a.pageId, children = _a.children;
    var _b = (0, react_1.useContext)(ModalContext_1.default), pageSetRef = _b.pageSetRef, animationState = _b.animationState, mobileStyle = _b.mobileStyle;
    var currentId = animationState.currentId, animatingId = animationState.animatingId, direction = animationState.direction;
    var visited = pageSetRef.current.has(pageId);
    var hidden = currentId !== pageId && pageId !== animatingId && !visited;
    var accessibilityHidden = pageId !== currentId;
    var isMobile = (0, useMediaQuery_1.default)("(max-width: ".concat(helios_styles_1.breakpoint.sm, ")"));
    if (!isMobile || mobileStyle !== 'sheet') {
        return currentId === pageId && (0, jsx_runtime_1.jsx)(Modal_styles_1.PageComponent, { children: children });
    }
    return ((0, jsx_runtime_1.jsx)(Modal_styles_1.PageComponent, __assign({ "aria-hidden": accessibilityHidden, 
        // @ts-ignore - React typescript doesn't support inert right now
        inert: accessibilityHidden ? '' : undefined, className: (0, classnames_1.default)({
            'Helios__page-slide-in': animatingId === pageId && direction > 0,
            'Helios__page-slide-out': animatingId === pageId && direction < 0,
            'Helios__page-visited': visited,
            Helios__hide: hidden
        }) }, { children: children })));
};
exports.Page = Page;
